import request from '../../utils/requests'
/** * Tag: Token */
const baseUrl ="/api/Token";

/** * 一手机号多账户查询 * @param {*} body * { *    account Desc:账户 Required:false *    password Desc:密码 Required:false *    orgid Desc:机构id Required:false *    remember Desc:记住密码 Required:false * } */async function _orgSelect(body) {  return request(baseUrl+'/orgSelect',{    method: 'POST',    body: body,  });
}

/** * 获取token * @param {*} body * { *    account Desc:账户 Required:false *    password Desc:密码 Required:false *    orgid Desc:机构id Required:false *    remember Desc:记住密码 Required:false * } */async function _getToken(body) {  return request(baseUrl+'/getToken',{    method: 'POST',    body: body,  });
}

/** * 根据openid获取token，实现快速登录 * @param {*} param * { *    openid Desc: Required:true * } */async function _getTokenByOpenId(param) {  return request(baseUrl+'/getTokenByOpenId',{    method: 'GET',    params: param,  });
}

export default{  _orgSelect,  _getToken,  _getTokenByOpenId}



// WEBPACK FOOTER //
// ./src/services/token.js